import { DownOutlined, RightOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { getReferenceData } from 'common/reference-data/containers/reference-data-actions';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Icon } from 'ui';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import PartList from '../../../order/parts/components/part-list';
import { severityColorCodes } from '../../../utils/app-configs';

const PartListWrapper = styled.div`
  padding: 20px 0;
  width: 100%;
  border-width: 3px 0;
  border-style: solid;
  border-color: lightgray;
  overflow-x: hidden;
`;

const PartWrapperText = styled.span`
  font-weight: 700;
  font-size: 17px;
  text-transform: uppercase;
`;

const OpenIcon = styled.span`
  cursor: pointer;
  margin-right: 5px;
  > span
    {
      width: 19px;
    }
`;

const StyledIcon = styled(Icon)`
  color: ${p => p.theme.colors.alerts[p.severity]} !important;
  margin-right: 5px;
`;

const XmlPartList = ({
  intl,
  index,
  form,
  serviceCenterId,
  parts,
  orderId,
  handlePartAction,
  handleRemoveSupersededPart,
  handleAddOfSupersededPart,
}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (orderId) {
      dispatch(getReferenceData({
        objectType: 'order',
        name: 'logisticsFlow',
        urlParams: { orderId },
        serviceCenterId,
      }),
      );
    }
  }, [orderId]);

  const showIcon = () => {
    const hasObsolete = parts?.some(part => part?.isObsolete);
    const hasSupersededBy = parts?.some(part => part?.supersededBy.length > 0);
    const hasAutoReplaced = parts?.some(part => part?.autoReplacementInfo?.isAutoReplaced);

    if (hasObsolete) {
      return <StyledIcon severity={severityColorCodes.high} type='triangle-exclamation' />;
    }

    if (hasSupersededBy) {
      return <StyledIcon severity={severityColorCodes.moderate} type='triangle-exclamation' />;
    }

    if (hasAutoReplaced) {
      return <StyledIcon severity={severityColorCodes.informational} type='square-info' />;
    }

    return null;
  };

  return (
    <PartListWrapper>
      <PartWrapperText>
        <OpenIcon onClick={() => setOpen(s => !s)}>
          {open ? <DownOutlined /> : <RightOutlined />}
        </OpenIcon>
        {intl.formatMessage(
          { id: 'common.titles.PARTS_TITLE_COUNT' },
          { count: parts?.length },
        )} {!open && showIcon()}
      </PartWrapperText>
      {open && <PartList
        partList={[]}
        onShowDetails={null}
        form={form}
        orderId={orderId}
        disabled={false}
        handleRemovePart={e => handlePartAction(e, index - 1, orderId, 'removePart')}
        handleAddPart={e => handlePartAction(e, index - 1, orderId, 'addPart')}
        shipTo={null}
        isFrozen={false}
        parts={parts}
        decimalMask={false}
        checkUpdate={false}
        serviceCenterId={serviceCenterId}
        handleRemoveSupersededPart={(supersededPartId, partId) =>
          handleRemoveSupersededPart(supersededPartId, partId, orderId, index - 1)}
        showPartlistAttributes={false}
        partListType='xmlView'
        handleAddOfSupersededPart={(supersededPart, originalPartId) =>
          handleAddOfSupersededPart(supersededPart, originalPartId, index - 1, orderId)}
      />}
    </PartListWrapper>
  );
};

XmlPartList.propTypes = {
  intl: PropTypes.object,
  index: PropTypes.number,
  form: PropTypes.object,
  serviceCenterId: PropTypes.string,
  parts: PropTypes.array,
  orderId: PropTypes.string,
  handlePartAction: PropTypes.func,
  handleRemoveSupersededPart: PropTypes.func,
  handleAddOfSupersededPart: PropTypes.func,
};

export default injectIntl(XmlPartList);
